export const GET_PROFILES = "GET_PROFILES"
export const GET_PROFILES_SUCCESS = "GET_PROFILES_SUCCESS"
export const API_ERROR = "API_ERROR"
